export const NEW_PATH = 'new';
